export class CollaborationTexts {
  static texts() {
    return {
      title: ET('mps2::collaboration::title'),
      creator_name: ET('mps2::collaboration::creator_name'),
      collaboration_type: ET('mps2::collaboration::collaboration_type'),
      collaboration_type_description: ET('mps2::collaboration::collaboration_type_description'),
      collaboration_category: ET('mps2::collaboration::collaboration_category'),
      collaboration_category_placeholder: ET('mps2::collaboration::collaboration_category_placeholder'),
      collaboration_category_etc_placeholder: ET(
        'mps2::collaboration::collaboration_category_etc_placeholder',
      ),
      proposal_content: ET('mps2::collaboration::proposal_content'),
      proposal_content_placeholder: ET('mps2::collaboration::proposal_content_placeholder'),
      proposal_content_description: ET('mps2::collaboration::proposal_content_description'),
      brand_name: ET('mps2::collaboration::brand_name'),
      brand_name_placeholder: ET('mps2::collaboration::brand_name_placeholder'),
      brand_url: ET('mps2::collaboration::brand_url'),
      brand_url_placeholder: ET('mps2::collaboration::brand_url_placeholder'),
      manager_name: ET('mps2::collaboration::manager_name'),
      manager_name_placeholder: ET('mps2::collaboration::manager_name_placeholder'),
      manager_tel: ET('mps2::collaboration::manager_tel'),
      manager_tel_placeholder: ET('mps2::collaboration::manager_tel_placeholder'),
      manager_email: ET('mps2::collaboration::manager_email'),
      manager_email_placeholder: ET('mps2::collaboration::manager_email_placeholder'),
      announcement: {
        explanation: ET('mps2::collaboration::announcement::explanation'),
        response: ET('mps2::collaboration::announcement::response'),
        rejection: ET('mps2::collaboration::announcement::rejection'),
        apply: ET('mps2::collaboration::announcement::apply', { href: `/${T.lang}/@/advance_reservation` }),
      },
      type: {
        group_buy: ET('mps2::collaboration::type::group_buy'),
        ads: ET('mps2::collaboration::type::ads'),
        live: ET('mps2::collaboration::type::live'),
        tiktok: ET('mps2::collaboration::type::tiktok'),
        youtube: ET('mps2::collaboration::type::youtube'),
      },
      category: {
        food: ET('mps2::collaboration::category::food'),
        beauty: ET('mps2::collaboration::category::beauty'),
        fashion_accessory: ET('mps2::collaboration::category::fashion_accessory'),
        electronics: ET('mps2::collaboration::category::electronics'),
        home_living: ET('mps2::collaboration::category::home_living'),
        pets: ET('mps2::collaboration::category::pets'),
        sports: ET('mps2::collaboration::category::sports'),
        travel: ET('mps2::collaboration::category::travel'),
        etc: ET('mps2::collaboration::category::etc'),
      },
      alert: {
        success_title: ET('mps2::collaboration::alert::success_title'),
        success_description: ET('mps2::collaboration::alert::success_description'),
      },
      cancel: ET('mps2::collaboration::cancel'),
      proposal_collaboration: ET('mps2::collaboration::proposal_collaboration'),
    };
  }
}
